import CompanyFinepTabList from ".";
import { CompanyContextFinepProvider } from "../../../Contexts/CompanyFinepContext";

const TabCompanyFinepContextChildren = () => {
    return (
        <CompanyContextFinepProvider>
            <CompanyFinepTabList />
        </CompanyContextFinepProvider>
    );
}

export default TabCompanyFinepContextChildren;